module.exports = __webpack_public_path__ + "ac8f540d1e91ccb656af38004da5d8e9.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/horse.png
// module id = 972
// module chunks = 2